/**
 * minionAggroPriority — Bridge target priority for ARAM minions (FID-MIN-02 / FID-MIN-05).
 * Rank: champion < minion < structure; distance tiebreak.
 */

export const MINION_AGGRO_RANK = Object.freeze({
  champion: 0,
  minion: 1,
  structure: 2,
  other: 3
});

export function minionAggroTargetRank(target) {
  if (!target) return MINION_AGGRO_RANK.other;
  const t = String(target.type || '');
  if (t === 'champion' || target.isChampion === true) return MINION_AGGRO_RANK.champion;
  if (t.startsWith('minion')) return MINION_AGGRO_RANK.minion;
  if (
    t === 'turret' ||
    t === 'inhibitor' ||
    t === 'nexus' ||
    target.isStructure === true
  ) {
    return MINION_AGGRO_RANK.structure;
  }
  return MINION_AGGRO_RANK.other;
}

/**
 * @returns {number} negative if a better than b
 */
export function compareMinionAggroTargets(a, b, self) {
  const ra = minionAggroTargetRank(a);
  const rb = minionAggroTargetRank(b);
  if (ra !== rb) return ra - rb;
  const da = Math.hypot(a.x - self.x, (a.z ?? a.y) - (self.z ?? self.y));
  const db = Math.hypot(b.x - self.x, (b.z ?? b.y) - (self.z ?? self.y));
  return da - db;
}

export function pickMinionAggroTarget(self, candidates = []) {
  let best = null;
  for (const c of candidates) {
    if (!c || c.isDead || c.team === self.team || c === self) continue;
    if (!best || compareMinionAggroTargets(c, best, self) < 0) best = c;
  }
  return best;
}
